namespace TabAurous {

    @Serenity.Decorators.registerEditor()
    export class CommonCategoryLookup extends
        Serenity.LookupEditorBase<Serenity.LookupEditorOptions, OMS.SubCategoryDetailsRow> {

        public ItemTypeId: number;

        constructor(container: JQuery, opt: Serenity.LookupEditorOptions) {
            super(container, opt);
        }

        protected getLookupKey() {
            return OMS.CategoryMasterRow.lookupKey;
        }

        protected getItems(lookup: Q.Lookup<any>) {
            var results = Q.getLookup(OMS.CategoryMasterRow.lookupKey);

            let items = super.getItems(results);
            if (q.isNumber(this.ItemTypeId)) {

                let filters = {
                    ItemTypeId: [this.ItemTypeId, 0],
                    IsDisabled: [false]
                };

                items = q.Filter(items, filters)
            }
            return items;
        }

    }


}
